import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo/logoPayoffNegativoColori.svg';
import IconFacebook from '../../assets/social/facebook.png';
import IconInstagram from '../../assets/social/instagram.png';
import IconTiktok from '../../assets/social/tikTok.png';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const {t} = useTranslation();
  return (
    <footer className="bg-burnt-coffee text-white pt-16 pb-32  w-full">
      <div className="w-full px-4 lg:px-16">
        {/* Sezione superiore */}
        <div className="relative flex flex-col space-y-4 md:space-y-0 md:flex-row md:items-start">
          {/* Testo sopra il logo */}
          <div className="text-start md:text-left text-sm">
            <p>&copy; {new Date().getFullYear()} {t('footer.rights')}</p>
            <p>{t('footer.pIva')}</p>
          </div>

          {/* Links — centrati in assoluto rispetto al container */}
          <div className="md:absolute md:inset-0 flex items-start justify-center pointer-events-none">
            <nav aria-label="Link footer" role="navigation" className="pointer-events-auto">
              <ul className="flex flex-wrap justify-center gap-4 list-none m-0 p-0">
                <li><Link to="/about-us" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.abousUs')}</Link></li>
                <li><Link to="/terms" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.terms')}</Link></li>
                <li><Link to="/privacy" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.privacy')}</Link></li>
                <li><Link to="/general-guide" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.guide')}</Link></li>
                <li><Link to="/faq" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.faq')}</Link></li>
                <li><Link to="/contact" className="font-heading text-base uppercase hover:text-claudy-blue"> {t('footer.contact')}</Link></li>
              </ul>
            </nav>
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-start md:justify-end gap-4 md:ml-auto">
            <a href="https://www.facebook.com/people/Save-Your-Travel/61574617740668/?locale=it_IT" target="_blank" rel="noopener noreferrer">
              <img src={IconFacebook} alt="Facebook" className="w-10 h-10 hover:opacity-75" />
            </a>
            <a href="https://www.instagram.com/saveyourtravel/?igsh=Mm5qZWVmeGZvdGl1" target="_blank" rel="noopener noreferrer">
              <img src={IconInstagram} alt="Instagram" className="w-10 h-10 hover:opacity-75" />
            </a>
            <a href="https://www.tiktok.com/@saveyourtravel?_t=ZN-8uckGuNw9UE&_r=1" target="_blank" rel="noopener noreferrer">
              <img src={IconTiktok} alt="TikTok" className="w-10 h-10 hover:opacity-75" />
            </a>
          </div>
        </div>

        {/* Logo + Startup badge */}
        <div className="relative flex flex-col items-center md:flex-row md:items-center pt-4 gap-3 md:gap-0">
          <img src={Logo} alt="Logo" className="w-32 md:w-44" />
          <div className="md:absolute md:inset-0 flex items-center justify-center pointer-events-none">
            <p className="font-heading text-sm uppercase tracking-widest text-claudy-blue text-center">
              {t('footer.startupInnovativa')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
